import React from 'react';

import {Author} from '../Services/AuthorService';

import AuthorProfile from './AuthorProfile';

interface AuthorWidgetProps {
  author?: Author;
}

function AuthorWidget({author}: AuthorWidgetProps) {
  if (author === undefined) {
    return <div />;
  }

  return (
    <div className="sidebar-widget-area">
      <h5 className="title">About the Author</h5>
      <div className="widget-content">
        <AuthorProfile author={author} />
      </div>
    </div>
  );
}

export default AuthorWidget;
